"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M426.7 154v13.1c0 121-94.9 264.8-265 264.8-52.3 0-98.2-13.1-144-39.2h22.9c45.8 0 85.1-13.1 117.8-39.2-39.3 0-75.2-26.2-85.1-62.1h16.4c9.8 0 16.4 0 22.9-3.3-42.5-13.1-75.2-49-75.2-91.5 16.4 3.3 32.7 9.8 45.8 9.8C57 190 40.7 160.6 40.7 127.9c0-16.3 3.3-32.7 13.1-45.8 45.8 52.3 111.2 94.8 193 98.1 0-9.8-3.3-13.1-3.3-22.9 0-49 39.3-94.8 94.9-94.8 26.2 0 49.1 13.1 68.7 32.7 22.9-3.3 39.3-13.1 58.9-22.9-9.8 22.9-22.9 39.2-39.3 49 16.4 0 36-9.8 52.3-13.1-16.3 19.7-35.9 36-52.3 45.8z"
  });
};

exports.default = _default;